import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  addManualLineItem,
  deleteManualLineItem,
  listManualLineItems,
  type ManualLineItem,
  type ManualLineItemInput,
} from "../api/manualLineItems";

export const MANUAL_LINE_ITEMS_KEY = "manual-line-items";

export function useManualLineItems(
  taskId: string | null | undefined,
  enabled = true,
) {
  return useQuery<ManualLineItem[]>({
    queryKey: [MANUAL_LINE_ITEMS_KEY, taskId],
    queryFn: () => listManualLineItems(taskId as string),
    enabled: !!taskId && enabled,
    retry: false,
  });
}

export function useAddManualLineItem() {
  const qc = useQueryClient();
  return useMutation<
    ManualLineItem,
    Error,
    { taskId: string; body: ManualLineItemInput }
  >({
    mutationFn: ({ taskId, body }) => addManualLineItem(taskId, body),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: [MANUAL_LINE_ITEMS_KEY, vars.taskId] });
    },
  });
}

export function useDeleteManualLineItem() {
  const qc = useQueryClient();
  return useMutation<void, Error, { taskId: string; itemId: string }>({
    mutationFn: ({ taskId, itemId }) => deleteManualLineItem(taskId, itemId),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: [MANUAL_LINE_ITEMS_KEY, vars.taskId] });
    },
  });
}
